import React from 'react'

const Team = () => {
  return (
 <>
   <div class="section" id="trainer">
      <div class="container flex">
        <div class="trainer">
          <img
            src="https://i.imgur.com/S3Ag8LS.jpeg"
            alt=""
            style={{width:'50vw'}}
          />
        
        

      
        </div>

      
      </div>
      <h2  style={{marginTop:'5rem'}}class="mb">
        give the weight it’s worth it’s gonna be  <br />
          <span style={{color:"#24DBDD"}}>worth</span>  the wait
        </h2>
    </div>

 </>
  )
}

export default Team